import classNames from "classnames";
import React from "react";
import { Button } from "semantic-ui-react";

const RoundedButton = ({ className, ...props }) => (
  <Button {...props} className={classNames("rounded-button", props)} />
);

export default RoundedButton;
